import { filter } from 'lodash/fp';
import r from '../Replacement';

class PageTitle {
    activeTitle = document.title;
    unreadNotificationCount = 0;

    getActiveTitle = () => this.activeTitle;

    setPageTitle = title => {
        const docTitle = filter(x => x, [title, r('header.companyName')]).join(' - ');
        document.title = this.renderUnreadNotificationCount() + docTitle;
        this.activeTitle = title;
    };

    updateUnreadNotificationCount = unreadNotificationCount => {
        this.unreadNotificationCount = unreadNotificationCount;
        this.setPageTitle(this.activeTitle);
    };

    renderUnreadNotificationCount = () => (this.unreadNotificationCount ? `(${this.unreadNotificationCount}) ` : '');
}

export const pageTitleService = new PageTitle();
